module.exports = __webpack_public_path__ + "static/media/bg-header-OCC.6c254684.png";